import React from 'react';
import './TicketItem.css';

/**
 * Ticket Item Component - Displays individual ticket details
 */
const TicketItem = ({ ticket, isAdmin, onStatusUpdate }) => {
  // Get priority color for visual indicator
  const getPriorityColor = (priority) => {
    const colors = {
      Low: '#4CAF50',
      Medium: '#FF9800',
      High: '#f44336'
    };
    return colors[priority] || '#999';
  };

  // Get status color for visual indicator
  const getStatusColor = (status) => {
    const colors = {
      Open: '#2196F3',
      'In Progress': '#FF9800',
      Resolved: '#4CAF50'
    };
    return colors[status] || '#999';
  };

  // Format date for display
  const formatDate = (date) => {
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Handle status change for admin
  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    if (onStatusUpdate) {
      onStatusUpdate(ticket._id, newStatus);
    }
  };

  return (
    <div className="ticket-item">
      {/* Header with title and priority */}
      <div className="ticket-header">
        <h4 className="ticket-title">{ticket.title}</h4>
        <span 
          className="priority-badge"
          style={{ backgroundColor: getPriorityColor(ticket.priority) }}
        >
          {ticket.priority}
        </span>
      </div>

      {/* Description */}
      <p className="ticket-description">{ticket.description}</p>

      {/* Meta information */}
      <div className="ticket-meta">
        <div className="ticket-meta-item">
          <span className="meta-label">Status:</span>
          
          {isAdmin ? (
            // Admin can change status via dropdown
            <select 
              className="status-select"
              value={ticket.status}
              onChange={handleStatusChange}
              style={{ borderColor: getStatusColor(ticket.status) }}
            >
              <option value="Open">Open</option>
              <option value="In Progress">In Progress</option>
              <option value="Resolved">Resolved</option>
            </select>
          ) : (
            // Employee just sees status
            <span 
              className="status-badge"
              style={{ backgroundColor: getStatusColor(ticket.status) }}
            >
              {ticket.status}
            </span>
          )}
        </div>

        <div className="ticket-meta-item">
          <span className="meta-label">Created by:</span>
          <span className="meta-value">
            {ticket.createdBy?.name || 'Unknown'}
          </span>
        </div>

        <div className="ticket-meta-item">
          <span className="meta-label">Created:</span>
          <span className="meta-value">
            {formatDate(ticket.createdAt)}
          </span>
        </div>

        {ticket.assignedTo && (
          <div className="ticket-meta-item">
            <span className="meta-label">Assigned to:</span>
            <span className="meta-value">
              {ticket.assignedTo.name}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketItem;